// extracted by mini-css-extract-plugin
export default {"SchoolLogoWidget":"SchoolLogoWidget_SchoolLogoWidget__v8gHR","SchoolLogoContent":"SchoolLogoWidget_SchoolLogoContent__BO4Ha","SchoolLogo":"SchoolLogoWidget_SchoolLogo__2g0WN"};